import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./Schema.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                           */
//#region src/schema/Schema.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-86862f28"]]);
//#endregion
export { n as default };

//# sourceMappingURL=Schema.vue.js.map